import React from "react"
//import I18n from "i18n-js/index.js.erb"

class List extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className="row select-all-none" style={{ marginBottom: -5 }}>
        <div className="col-md-12">
          <div className="toggle">
            {this.props.title_helper_text
              ? <span>{`${I18n.t(this.props.header_primary).includes('missing') ? this.props.header_primary : I18n.t(this.props.header_primary)}`}{this.props.header_secondary ? ` (${I18n.t(this.props.header_secondary)})` : ''}{this.props.header_third ? ` (${I18n.t(this.props.header_third)})` : ''}{' '}<span className="ss-help help" title={I18n.t(this.props.title_helper_text)}></span></span>
              : <span>{`${I18n.t(this.props.header_primary).includes('missing') ? this.props.header_primary : I18n.t(this.props.header_primary)}`}{this.props.header_secondary ? ` (${I18n.t(this.props.header_secondary)})` : ''}{this.props.header_third ? ` (${I18n.t(this.props.header_third)})` : ''}{' '}</span>
            }  
          </div>
          <hr />
          <ul>
            {this.renderData()}
          </ul>
        </div>
      </div>
    )
  }

  renderData() {
    return this.props.items.map((item, idx) => {
      var display_columns = this.props.display_column_primary.split(' ')
      if (this.props.custom_display_column_secondary && this.props.show_disabled_rate) {
        var disabled_rate_status = item.status
      }
      return (
        <li key={item.id ? item.id : this.props.keyString ? item[this.props.keyString] : idx }>
          {display_columns.map((column, idx) => {
            if (display_columns[idx + 1]) {
              return item[column] + ': '
            }
            return item[column]
          })}
          {this.props.display_column_secondary
            ? ` (${item[this.props.display_column_secondary]})`
            : ''
          }
          {this.props.owner_details_secondary_column
            ? <span> (<span style={{ color: '#666', fontStyle: 'italic' }}>{item.room_type}</span>) (<span style={{ color: '#666', fontStyle: 'italic' }}>{item.owner_names}</span>)</span>
            : ''
          }
          {this.props.room_type_secondary_column
          ? ` (${this.props.room_type_secondary_column})`
          : ''
          }
          {this.props.display_column_percentage
            ? ` (${item.percentage * 100}%)`
            : ''
          }
          {disabled_rate_status === 'disabled'
            ? <span><em>{` (${I18n.t('Disabled')})`}</em>{` (${item[this.props.custom_display_column_secondary]})`}</span>
            : ''
          } 
          {this.props.show_status && item.status == 'disabled' 
            ? <em>{` (${I18n.t('Disabled')})`}</em> 
            : ''
          }
        </li>
      )
    })
  }
}

export default List